var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transitionName}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],class:['back-to-ceiling', _vm.className],on:{"click":_vm.backToTop}},[_c('img',{attrs:{"src":require("@icon/top.png"),"alt":"toTop"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }